<template>
  <div class="frame-user-info">
    <img :src="icon" alt="head">
    <div class="user-name">
      <span>{{ nickName }}</span>
      <ul>
        <li @click="userInfo()"><i class="icomoon-profile"></i>个人信息</li>
        <!-- <li @click="isChangePassword = true"><i class="icomoon-key"></i>修改密码</li> -->
        <li @click="logout()"><i class="icomoon-switch"></i>退出平台</li>
      </ul>
    </div>
    <teleport to=".base">
      <window title="修改密码" class="dark" windowId="change-password" v-show="isChangePassword"
        @windowHide="passwordClose()">
        <template #body>
          <el-form ref="form" class="line pd-20" :model="password" :rules="rules">
            <div class="insert-h">
              <div class="attr">原始密码</div>
              <div class="val">
                <el-form-item prop="old" class="line">
                  <el-input type="password" v-model="password.old" placeholder="请输入原始密码"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="insert-h">
              <div class="attr">新密码</div>
              <div class="val">
                <el-form-item prop="new" class="line">
                  <el-input type="password" v-model="password.new" placeholder="新密码由6位以上字符组成"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="insert-h">
              <div class="attr">重复密码</div>
              <div class="val">
                <el-form-item prop="repeat" class="line">
                  <el-input type="password" v-model="password.repeat" placeholder="重复密码必须与新密码一致"></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </template>
        <template #footer>
          <div class="line pd-20 align-right">
            <el-button @click="passwordClose()">取消</el-button>
            <el-button type="primary" @click="changePassword()">确定</el-button>
          </div>
        </template>
      </window>
    </teleport>
  </div>
</template>
<script>
import Window from "components/common/forms/Window";
export default {
  name: 'User',
  components: {
    Window
  },
  data () {
    return {
      rules: {
        old: [{ required: true, message: '原始密码不能为空', trigger: 'blur' }],
        new: [{ required: true, message: '新密码不能为空', trigger: 'blur' }],
        repeat: [{ required: true, message: '重复输入密码不能为空', trigger: 'blur' }],

      },
      defaultHead: require("assets/images/frame/default-head.svg"),
      isChangePassword: false,
      password: {
        old: "",
        new: "",
        repeat: "",
      },
    }
  },
  computed: {
    nickName: function () {
      return this.$store.state.user ? this.$store.state.user.userInfo.nickname : '';
    },
    icon: function () {
      return this.$store.state.user ? (this.$store.state.user.userInfo.icon != '-1' ? '/file/' + this.$store.state.user.userInfo.icon : this.defaultHead) : this.defaultHead;
    },
  },
  methods: {
    logout () {
      let self = this;
      self.$store.dispatch("signOut").then(() => {
        self.$bus.emit('isLogin', false);
        self.$router.replace('/Index');
      });
    },
    userInfo () {
      let self = this;
      self.$router.replace('/Mgt/UserInfo')
    },
    passwordClose () {
      let self = this;
      self.isChangePassword = false;
      self.password.old = "";
      self.password.new = "";
      self.password.repeat = "";
    },
    changePassword () {
      let self = this;
      self.$api.auth.changePass({
        oldPass: self.password.old,
        newPass: self.password.new
      }).then(data => {
        self.$message.success('修改成功');
        self.isChangePassword = false;
      })
    },
  }
}
</script>